import { typeMethods } from './utils'

export default {
	props: {
		order: {
			default: '',
		},
		injured: {
			default: '',
		},
		boardImageList: {
			default: '',
		},
		setting: {
			default: '',
		},
	},
	computed: {
		...typeMethods,
	},
	methods: {
		checkParams(options) {
			const { order, injured, boardImageList, setting } = this
			if (!setting) {
				console.error('缺少字典值对象')
				return false
			}
			return true
		},
	},
}
